import React from 'react';

/**
 * Rémi, la mascotte ATABLE (écureuil du site). Rendu en image pour être
 * identique partout : site, app mobile, dashboard. Accepte `className`
 * pour la taille (ex. "w-10 h-10") comme l'ancienne icône SVG.
 */
export const RemiIcon: React.FC<{ className?: string; alt?: string } & Record<string, unknown>> = ({ className = '', alt = 'Rémi' }) => (
    <img
        src="/brand/remi.png"
        alt={alt}
        className={`object-contain select-none ${className}`}
        draggable={false}
    />
);
